import { render, staticRenderFns } from "./IFile.vue?vue&type=template&id=f66871a6&scoped=true&lang=pug"
import script from "./IFile.vue?vue&type=script&lang=js"
export * from "./IFile.vue?vue&type=script&lang=js"
import style0 from "./IFile.vue?vue&type=style&index=0&id=f66871a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66871a6",
  null
  
)

export default component.exports